import React from 'react'
import PropTypes from 'prop-types'
import { Accordion, Button, Modal, Popup } from 'semantic-ui-react'

const EndUserAuthenticationModal = ({
  disabled,
  modalOpen,
  handleOpen,
  handleClose,
  email,
  password,
  onEmailChange,
  onPasswordChange,
  onClickAuthenticate,
  authenticateEndUser,
  endUserAuthenticationFormSubmitButtonRef,
  isZendeskEndUserAuthenticationFailed,
  isLoading,
}) => (
  <Modal
    size="small"
    open={modalOpen}
    onClose={handleClose}
    trigger={
      disabled ? (
        <Popup
          basic
          trigger={
            <div>
              <button className="ui primary button" disabled>
                Activate integration
              </button>
            </div>
          }
        >
          Please activate the integration above first.
        </Popup>
      ) : (
        <button className="ui primary button" onClick={handleOpen}>
          Activate integration
        </button>
      )
    }
  >
    <Modal.Header>Authenticate End-user with Zendesk</Modal.Header>
    <Modal.Content>
      <EndUserAccordion
        email={email}
        password={password}
        onEmailChange={onEmailChange}
        onPasswordChange={onPasswordChange}
        isZendeskEndUserAuthenticationFailed={isZendeskEndUserAuthenticationFailed}
        authenticateEndUser={authenticateEndUser}
        endUserAuthenticationFormSubmitButtonRef={endUserAuthenticationFormSubmitButtonRef}
      />
    </Modal.Content>
    <Modal.Actions>
      <button className="ui deny button" onClick={handleClose}>
        Cancel
      </button>
      <Button primary loading={isLoading} onClick={onClickAuthenticate}>
        Authenticate
      </Button>
    </Modal.Actions>
  </Modal>
)

EndUserAuthenticationModal.propTypes = {
  disabled: PropTypes.bool,
  modalOpen: PropTypes.bool.isRequired,
  handleOpen: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  onEmailChange: PropTypes.func.isRequired,
  onPasswordChange: PropTypes.func.isRequired,
  onClickAuthenticate: PropTypes.func.isRequired,
  isZendeskEndUserAuthenticationFailed: PropTypes.bool,
  isLoading: PropTypes.bool,
}

const EndUserAccordion = ({
  email,
  password,
  onEmailChange,
  onPasswordChange,
  isZendeskEndUserAuthenticationFailed,
  authenticateEndUser,
  endUserAuthenticationFormSubmitButtonRef,
}) => (
  <Accordion
    styled
    exclusive
    defaultActiveIndex={0}
    fluid
    panels={[
      {
        title: 'Step 1: Create a fake end-user account',
        content: {
          key: 'step1-content',
          content: (
            <div>
              <p>
                Zendesk doesn't allow admins to add or update satisfaction ratings through the API
                to prevent agent cheating. To get around this, you need to authenticate with a
                second end-user account that we'll use to update the ratings.
              </p>
              <p>
                When your customer provides a rating, we'll change the ticket's requester to the new
                fake account, rate it, then switch back to the original requester.
              </p>
              <a
                href="https://help.simplesat.io/en/articles/7154584-zendesk-integrations#h_d2cd8028d7"
                target="_blank"
                rel="noreferrer"
              >
                Create a new end-user to send ratings back to Zendesk
              </a>
            </div>
          ),
        },
      },
      {
        title: `Step 2: Authenticate with end-user's credentials`,
        content: {
          key: 'step2-content',
          content: (
            <div>
              {isZendeskEndUserAuthenticationFailed ? <WarningMessage /> : null}
              <p>Once you create the fake end-user, enter their credentials below.</p>
              <form className="ui form" onSubmit={authenticateEndUser}>
                <div className="field">
                  <label>End-user Email</label>
                  <input type="text" value={email} onChange={onEmailChange} required />
                </div>
                <div className="field">
                  <label>End-user Password</label>
                  <input type="password" value={password} onChange={onPasswordChange} required />
                </div>
                <button hidden type="submit" ref={endUserAuthenticationFormSubmitButtonRef} />
              </form>
            </div>
          ),
        },
      },
    ]}
  />
)

EndUserAccordion.propTypes = {
  email: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  onEmailChange: PropTypes.func.isRequired,
  onPasswordChange: PropTypes.func.isRequired,
  isZendeskEndUserAuthenticationFailed: PropTypes.bool,
}

const WarningMessage = () => (
  <div className="ui negative message">
    <div className="header">Authentication Unsuccessful</div>
    <p>Please double check your credentials and try again.</p>
  </div>
)

export default EndUserAuthenticationModal



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/Admin/Surveys/ZendeskIntegrationSettings/EndUserAuthenticationModal.js